import React, { useRef, useState } from "react";
import moment from "moment";
import { Button, Flex, Box, Text, Spinner } from "samba-ui";
import { CSVLink } from "react-csv";
import { getAcrOutages } from "../api";
import serialize from "../utils/serialize";

const dateFormat = "YYYY-MM-DD HH:mm";

const DownloadQueryResultsButton = ({
  duration,
  selectedCountry,
  selectedCallsign,
  provider,
  channelId,
  startDate,
  endDate,
  incidentState,
  totalSize
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const csvInstance = useRef();

  const showButton =
    (selectedCountry.value !== "ALL" ||
      selectedCallsign.value !== "ALL" ||
      provider ||
      channelId ||
      startDate ||
      endDate ||
      incidentState.value !== "ALL" ||
      duration) &&
    totalSize < 400;

  const getQueryParams = () => {
    let queryParam = {
      page: 1
    };
    if (selectedCountry.value !== "ALL") {
      queryParam["channel_country"] = selectedCountry.value;
    }

    if (selectedCallsign.value !== "ALL") {
      queryParam["callsign"] = selectedCallsign.value;
    }

    if (provider) {
      queryParam["provider_longname"] = provider;
    }

    if (channelId) {
      queryParam["channel_id"] = channelId;
    }

    if (startDate) {
      queryParam["start_timestamp"] = moment(
        moment.utc(startDate.format(dateFormat)).valueOf()
      ).format(dateFormat);
    }

    if (endDate) {
      queryParam["end_timestamp"] = moment(
        moment.utc(endDate.format(dateFormat)).valueOf()
      ).format(dateFormat);
    }

    if (incidentState.value !== "ALL") {
      queryParam["incident_state"] = incidentState.value;
    }

    if (duration) {
      queryParam["duration"] = duration;
    }

    if (totalSize) {
      queryParam["size"] = totalSize * 20;
    }

    return serialize(queryParam);
  };

  const onButtonClick = async () => {
    setLoading(true);
    const res = await getAcrOutages(getQueryParams());
    const { data } = await res.json();
    setData(data.outages);
    setLoading(false);
    if (csvInstance && csvInstance.current && csvInstance.current.link) {
      setTimeout(() => {
        csvInstance.current.link.click();
      }, 100);
    }
  };

  if (!showButton) {
    return null;
  }

  return (
    <Box mt={3}>
      <CustomButton onClick={loading ? () => {} : onButtonClick}>
        {loading ? (
          <Flex justifyContent="center" alignItems="center">
            <Spinner variant="small" />
          </Flex>
        ) : (
          <Text>Download CSV</Text>
        )}
      </CustomButton>
      <CSVLink
        filename={"acr-query-results.csv"}
        data={data}
        ref={csvInstance}
      ></CSVLink>
    </Box>
  );
};

export default DownloadQueryResultsButton;

const CustomButton = ({ children, onClick }) => {
  return (
    <Button
      onClick={onClick}
      variant="secondary"
      width="100%"
      height={"50px !important"}
    >
      {children}
    </Button>
  );
};
